import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import { BookOpen, Film, Heart, Home, MessageSquare, PlusSquare, Users } from 'react-feather';
import { useAuth, useTheme } from '../../global-components/src';
import { useNotifications } from '../../hooks/UseNotifications';
import { Menu, PlusCircle } from 'lucide-react';
import { System } from "../../global-components/src/types";
import NavbarPCLink from '../../global-components/src/components/navbar-pc/navbar-pc-link';
import { AppsLinkPC } from '../../global-components/src/components/navbar-pc/apps-link-pc';
import Nav from "../../global-components/src/components/navbar-pc/navbar-pc";
import PreviewSearchPC from '../../pages/Settings/SearchScreen/preview-search-pc';
import { NotificationBadge, NotificationChatBadge } from '../../hooks/notifications';
import { Icon } from '../../global-components/src/components/icon';
import { useLocation, useNavigate } from 'react-router-dom';
import { set } from 'lodash';
import { useFeed } from '../../contexts/FeedContext';
import { t } from 'i18next';

const NavbarPC: React.FC = () => {
    const { isAuthenticated } = useAuth();
    const location = useLocation();
    const path = location.pathname;
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [isFocus, setIsFocus] = useState(false);
    const [text, setText] = useState("");
    const [suggestions, setSuggestions] = useState<any>([]);
    const textareaRef = useRef<HTMLInputElement>(null);
    const { isDarkMode, isNewUI } = useTheme();
    const { feedType, setPosts, setFeedType, setEnd, setPage } = useFeed();
    const navigate = useNavigate();

    const resetHome = () => {
        if(path != "/"){
            navigate("/");
            return
        }
        setPage(-1);
    }

    return (
        <Nav 
            showMenuIcon={isAuthenticated}
            searchForm={
                <div style={{ position: "relative" }}>
                    <form className="d-flex" method="GET" action={"/pesquisa"} role="search" id='form-search'>
                        <input onFocus={() => {setIsFocus(true); }} onBlur={() => { setTimeout(() => setIsFocus(false), 150) }}  ref={textareaRef} value={text} onChange={(val) => {setText(val.target.value); if(val.target.value.trim().length)  setShowSuggestions(true)} } className="form-control search-menu" id="input-search" type="text" name="termo" placeholder={t("generics.search")} aria-label="termo"/>
                            <button className="btn btn-search-menu" type="submit">
                                <img height="30px" src="/img/search.png" alt=""/>
                            </button>
                    </form>
                    <PreviewSearchPC isFocus={isFocus} textareaRef={textareaRef} text={text} setText={setText} showSuggestions={showSuggestions} setShowSuggestions={setShowSuggestions} suggestions={suggestions} setSuggestions={setSuggestions}/>
                </div>
                
            } 
            showSearchForm={true} className="fixed-top" img="/img/pacoca-sem-braco.png">
                <>
                    <NavbarPCLink onClick={resetHome} link="/" aria-label="Ir para home">
                        <Icon  invertColor={(isNewUI && !isDarkMode) || (!isNewUI && isDarkMode)} active={path == "/"} alt="Ir para home" size={32} name="home">
                            <Home className={`icon-menu-dark ${path == "/" ? 'active' : ''}`}/>
                        </Icon>
                    </NavbarPCLink>


                    {isAuthenticated ? (
                        <>
                            <AppsLinkPC system={System.pacoca} />

                            <NavbarPCLink className='position-relative' link="/chat" aria-label="Ir para o chat">
                                <Icon invertColor={(isNewUI && !isDarkMode) || (!isNewUI && isDarkMode)} active={path == "/chat"} alt="Ir para home" size={32} name="mail">
                                    <MessageSquare className="icon-menu-dark"/>
                                </Icon>
                                {window.innerWidth > 850 ? (
                                    <NotificationChatBadge />
                                ) : null}
                            </NavbarPCLink>
                        </>
                    ) : null}

                    <NavbarPCLink link="/flow" aria-label="Ir para o Flow">
                        <Icon invertColor={(isNewUI && !isDarkMode) || (!isNewUI && isDarkMode)} active={path.startsWith("/flow")} alt="Ir para o Flow" size={32} name="movie">
                            <Film className={`icon-menu-dark ${path.startsWith("/flow") ? 'active' : ''}`}/>
                        </Icon>
                    </NavbarPCLink>

                    <NavbarPCLink link="/blog" aria-label="Ir para o Blog">
                        <Icon invertColor={(isNewUI && !isDarkMode) || (!isNewUI && isDarkMode)} active={path.startsWith("/blog")} alt="Ir para o blog" size={32} name="article">
                            <BookOpen className={`icon-menu-dark ${path.startsWith("/blog") ? 'active' : ''}`}/>
                        </Icon>
                    </NavbarPCLink>

                { isAuthenticated ? (
                    <>
                        <NavbarPCLink link="/comunidades" aria-label="Ir para as comunidades">
                            <Icon invertColor={(isNewUI && !isDarkMode) || (!isNewUI && isDarkMode)} active={path == "/comunidades"} alt="Ir para home" size={32} name="group">
                                <Users className="icon-menu-dark"/>
                            </Icon>
                        </NavbarPCLink>

                        <li className="nav-item">
                            <span className="nav-link cursor-pointer" data-bs-toggle="modal" data-bs-target="#modal-post">
                                <Icon invertColor={(isNewUI && !isDarkMode) || (!isNewUI && isDarkMode)} alt="Ir para home" size={32} name="add_circle">
                                    <PlusCircle className="icon-menu-dark"/>
                                </Icon>
                            </span>
                        </li>

                        <NavbarPCLink className='position-relative' link="/notificacoes" aria-label="Ir para as notificações">
                            <Icon invertColor={(isNewUI && !isDarkMode) || (!isNewUI && isDarkMode)} active={path == "/notificacoes"} alt="Ir para home" size={32} name="favorite">
                                <Heart className={`icon-menu-dark`}/>
                            </Icon>
                            
                            {window.innerWidth > 850 ? (
                                <NotificationBadge />
                            ) : null}
                        </NavbarPCLink>
                        </>
                ) : null }
            </>
        </Nav>
    );
};

export default NavbarPC;
